import { IAppUser } from "../../models/AppUser";
import { EAppLanguages } from "../../utils/localization";

export interface IAuthContext {
    // Properties
    initialized: boolean;
    loggingIn: boolean;
    loginError?: string;
    loggedIn: boolean;
    user?: IAppUser;
    token?: string;
    returnHref?: string;
    lang?: string;
    anonymousSession: boolean;
    applicationGuid?: string | null;

    sessionCacheKey: string;

    // Methods
    //  logIn: (username: string, password: string, remember?: boolean) => void;
    loginWithUser: (user: IAppUser, sid: string) => void;
    loginWithAnonymousToken: (sid: string) => void;
    changeLanguage: (lang: string) => void;

    //loginWithCookie: () => void;

    logOut: () => void;
    initialize: () => void;
}

const noop = () => undefined;

export const initialAuthContext: IAuthContext = {
    initialized: false,
    loggedIn: false,
    loggingIn: false,
    anonymousSession: false,
    lang: EAppLanguages.FI,

    sessionCacheKey: "null",
    //  logIn: noop,
    loginWithUser: noop,
    loginWithAnonymousToken: noop,
    changeLanguage: noop,
    //  loginWithCookie: noop,
    logOut: noop,
    initialize: noop,
};
